import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import BlankLayout from '../BlankLayout';
import { disableAnonCreation, useUser } from '../../hooks/useUser';
import { useAuth } from '../../hooks/useAuth';
import { getPortalBranding, getLoanTypeLabel } from '../../utils/portalBranding';
import { isFromLendAPICombinedFunnel } from '../../utils/logoutRedirectHelper';

type Props = {};

const LendAPILogoutView: React.FC<{ boatLoansUrl: string; loanTypeLabel: string }> = ({
  boatLoansUrl,
  loanTypeLabel,
}) => (
  <h3 style={{ marginTop: '1rem', fontWeight: 'normal' }}>
    To learn more about {loanTypeLabel}, click{' '}
    <a
      href={boatLoansUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'underline' }}
    >
      here
    </a>
    .
  </h3>
);

const LogoutStep: React.FC<Props> = observer(() => {
  const user = useUser();
  const auth = useAuth();
  const location = useLocation();
  const fromLendAPICombined = isFromLendAPICombinedFunnel(location.search);
  const sourceId = Number(new URLSearchParams(location.search).get('source')) || undefined;
  const { boatLoansUrl, label } = getPortalBranding(sourceId);
  const loanTypeLabel = getLoanTypeLabel(label);

  useEffect(() => {
    disableAnonCreation();
    auth.signOut();
  }, [auth]);

  return (
    <BlankLayout>
      {user && !user.isAnonymous ? (
        <Spin size="large" style={{ marginTop: '2rem', display: 'block' }} />
      ) : (
        <div style={{ textAlign: 'center' }}>
          <h1>You have been logged out</h1>
          {fromLendAPICombined && (
            <LendAPILogoutView boatLoansUrl={boatLoansUrl} loanTypeLabel={loanTypeLabel} />
          )}
        </div>
      )}
    </BlankLayout>
  );
});

export default LogoutStep;
